import moment from "moment";
import React, { useEffect, useState } from "react";
import lunas from "../../assets/images/icon_mutation/lunas.svg";
import wallet from "../../assets/images/icon_topup/wallet.svg";
import done from "../../assets/images/icon_mutation/done.svg";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { formatCurrency } from "../../config/global";
import { setLoading } from "../../core/feature/config/configSlice";
import { getAllTopupHistory } from "../../core/service/api_topup";
import { StatsMutation } from "../common/home/Stats";
import filter from "../../assets/images/icon_invoice/filter.svg";
import { Transition } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import { BackButton } from "../common/BackButton";
import CustomApp from "../../core/models/customApp";
import { useAppSelector } from "../../core/feature/hooks";
import { isDarkColor } from "../../config/DarkColorChecker";

const ComponentTopupHistory = () => {
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const [history, setHistory] = useState<any>([]);
  const dispatch = useDispatch();
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState(moment().format("DD-MM-YYYY"));
  const [fromDateOlder, setFromDateOlder] = useState("");
  const [toDateOlder, setToDateOlder] = useState("");
  const fromDate = moment().subtract(90, "days").format("DD-MM-YYYY");
  const [total, setTotal] = useState(0);
  const [showDetail, setShowDetail] = useState(false);
  const [detail, setDetail] = useState<any>([]);
  const { t } = useTranslation();
  var n = `${t("TOPUP-HISTORY.reff")}`;
  var empty = `${t("TOPUP-HISTORY.reff")}`;

  useEffect(() => {
    getHistory();
  }, []);

  const getHistory = async () => {
    dispatch(setLoading(true));
    getAllTopupHistory(page, size)
      .then((res: any) => {
        setHistory(res.data.content);
        setTotal(res.data.totalElements);
        console.log(res.data.content);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const changePage = (newPage: any) => {
    setPage(newPage);
    dispatch(setLoading(true));
    getAllTopupHistory(newPage, size)
      .then((res: any) => {
        setHistory(res.data.content);
        console.log(res.data.content);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const changeSize = (newSize: any) => {
    setSize(newSize);
    dispatch(setLoading(true));
    getAllTopupHistory(0, newSize)
      .then((res: any) => {
        setHistory(res.data.content);
        console.log(res.data.content);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const getDetail = async (item: any) => {
    setShowDetail(true);
    setDetail(item);
    console.log(item);
  };

  return (
    <div className="bg-psp-primary pb-20 font-montserrat">
      <StatsMutation />
      <div className="container-fluid">
        <div className="mx-auto w-full container md:-mt-30 -mt-20 p-4 relative justify-between items-left bg-white  shadow rounded-2xl">
          <div className="flex mb-10  ">
            <BackButton />
            <div className="text-4xl font-bold ml-3">
              {t("TOPUP-HISTORY.title")}
            </div>
          </div>
          {/* <div className="container mb-3">
            <img src={filter} alt="" className="absolute float-left mt-2 ml-4"></img>
            <select className="bg-slate-100 text-dark px-16 py-2 left-0 rounded-lg mb-1 ml-1">
              <option>Filter</option>
            </select>
          </div>
          <div>
            <select className="bg-slate-100 text-slate-300 px-3 py-1 rounded-lg ml-4">
              <option>Pilih Bulan</option>
            </select>
            <button className="relative float-right bg-[#D654EB] py-2 w-[150px] rounded-xl text-white hover:bg-[#9d41ab]">Download</button>
            <select className="bg-slate-100 text-slate-300 px-3 py-1 rounded-lg ml-4">
              <option>Pilih Tahun</option>
            </select>
          </div>
          <div className="mt-6">
            <p className="text-2xl pl-3 text-slate-400 mb-6">History</p>
          </div> */}
          <div>
            {history.length < 1 ? (
              <div className="flex justify-center">
                <span className="text-slate-400">
                  {t("TOPUP-HISTORY.empty")}
                </span>
              </div>
            ) : (
              <div>
                {history.map((item: any, i: any) => {
                  return (
                    <div
                      key={i}
                      className="justify-end flex relative bg-white rounded-l-xl rounded-r-2xl shadow-md mb-4 mx-auto"
                    >
                      <div className="flex ml-5 rounded-r-xl flex-row relative w-full bg-white">
                        <div>
                          <img src={wallet} alt="" className="py-6 px-3"></img>
                        </div>
                        <div className="mt-3 ml-4">
                          <p>
                            {moment(item.dateTime).format(
                              "DD / MM / YYYY, HH:mm "
                            )}{" "}
                            <br />{" "}
                            <span className="mr-4 font-bold">{item.name}</span>
                            <br />
                            <span className="text-slate-500">
                              {item.callerName}
                            </span>{" "}
                          </p>
                        </div>
                        <div className="mt-2">
                          <div className="flex flex-col absolute text-right right-[200px] mt-3">
                            <span>{t("TOPUP-HISTORY.balance")}</span>
                            <span className="text-2xl font-bold text-[#48B699]">
                              {formatCurrency(item.amount)}
                            </span>
                          </div>
                          <div className="flex absolute right-3">
                            <button
                              onClick={() => getDetail(item)}
                              style={{
                                backgroundColor: customApp.app_accent_color,
                              }}
                              className={`relative float-right py-2 w-[150px] rounded-xl mr-2 mt-4 font-semibold hover:bg-blue-800 hover:shadow-md transition ${isDarkColor(customApp?.app_accent_color)?'text-white':'text-black'}`}
                            >
                              Detail
                            </button>
                            {/* <button className="relative float-right bg-[#D654EB] py-2 w-[150px] rounded-xl text-white mt-4 font-semibold hover:bg-[#9d41ab] hover:shadow-md transition">
                              Download
                            </button> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
          <div className="flex relative mt-10 justify-between">
            <div className="pt-2 w-1/4">
              <p>
                {t("OTHER.showing")} {page + 1} {t("OTHER.to")} {size}{" "}
                {t("OTHER.from")} {total} {t("OTHER.en")}
              </p>
            </div>
            <div className="w-auto">
              <div className="">
                <select
                  onChange={(value) => {
                    changeSize(value.target.value);
                  }}
                  value={size}
                  className="py-2 border rounded-lg bg-white"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                  <option value={1000}>1000</option>
                </select>
                <span className="ml-1">{t("OTHER.entry")}</span>
              </div>
            </div>
            <div className="flex w-1/4">
              <button
                onClick={() => changePage(page - 1)}
                disabled={page === 0}
                className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
              >
                {t("OTHER.previous")}
              </button>
              <button
                onClick={() => changePage(page + 1)}
                disabled={(page + 1) * size > total}
                className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
              >
                {t("OTHER.next")}
              </button>
            </div>
          </div>
        </div>
      </div>
      <Transition
        show={showDetail}
        enter="transition-opacity duration-200"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-3xl">
              <div className="border-0 rounded-2xl shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                <div className="relative p-6 flex-auto">
                  <div className="flex flex-col border-b-2 pb-3 mb-4">
                    <div className="text-center flex flex-col">
                      <span className="text-xl mt-3">
                        {t("TOPUP-HISTORY.balance")}
                      </span>
                      <span className="text-4xl text-[#48B699] font-bold mb-2">
                        {formatCurrency(detail.amount)}
                      </span>
                      <span>
                        {moment(detail.dateTime).format("DD/MM/YYYY, HH : mm")}
                      </span>
                      <span className="font-bold mt-">{detail.callerName}</span>
                    </div>
                  </div>
                  <div className="flex flex-row">
                    <div className="mr-20">
                      <p>{t("TOPUP-HISTORY.method")}</p>
                      <p>{t("TOPUP-HISTORY.nominal")}</p>
                      <p>{t("TOPUP-HISTORY.refNumber")}</p>
                    </div>
                    <div className="text-end">
                      <p>{detail.channel === "WEB" ? "Transfer" : "Cash"}</p>
                      <p>{formatCurrency(detail.amount)}</p>
                      <p>
                        {detail.reffNumber === "" ? "-" : detail.reffNumber}
                      </p>
                    </div>
                  </div>
                  <div>
                    <div>
                      <button
                        onClick={() => setShowDetail(false)}
                        className="w-full text-white bg-red py-2.5 rounded-full mt-3"
                      >
                        Tutup
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      </Transition>
    </div>
  );
};

export default ComponentTopupHistory;
